//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getAction } from '@/api/manage';
export default {
  name: 'SiteLimiter',
  data: function data() {
    return {
      pagePath: '/comm/api/siteLimiterAll',
      pageTitle: '在线站点',
      loading: true,
      dataSource: [],
      columns: [{
        title: '序号',
        dataIndex: '',
        key: 'rowIndex',
        width: 80,
        fixed: 'left',
        align: 'center',
        customRender: function customRender(t, r, index) {
          return parseInt(index) + 1;
        }
      }, {
        dataIndex: 'siteMn',
        title: '站点编号',
        align: 'center'
      }, {
        dataIndex: 'siteName',
        title: '站点名称',
        align: 'center'
      }, {
        dataIndex: 'time',
        title: '解禁时间',
        align: 'center'
      }, {
        title: '操作',
        dataIndex: 'action',
        align: 'center',
        width: 120,
        scopedSlots: {
          customRender: 'action'
        }
      }]
    };
  },
  mounted: function mounted() {
    this.loadData();
  },
  methods: {
    loadData: function loadData() {
      var _this = this;

      this.loading = true;
      getAction(this.pagePath, {}).then(function (res) {
        if (res.success) {
          _this.dataSource = res.result;
        } else {
          _this.$message.warning('系统异常=>' + res.message);
        }

        _this.loading = false;
      });
    },
    enableSite: function enableSite(siteMn) {
      var _this2 = this;

      getAction("comm/api/" + siteMn + "/enable", {}).then(function (res) {
        if (res.success) {
          _this2.$message.success('解禁成功！');
        } else {
          _this2.$message.warning('解禁失败！');
        }

        _this2.loadData();
      });
    }
  }
};